import { IGenericResponse } from "src/apis/helpers/baseModels/IGenericResponse";
import { Api } from "src/apis/helpers/configs/api";
import { StandardsDto } from "src/data/models/standardsDtos/standardsDto.interface";
import BaseRepository from "../Base/BaseRepository";
import IStandardsRepository from "./IStandardsRepository";

export default class StandardsRepository extends BaseRepository implements IStandardsRepository {

  async getStandards(): Promise<IGenericResponse<Array<StandardsDto>>> {

    const result = this.CreateRequestBuilder()

    const request = result
      .setMethod('get')
      .setUrl(Api.Standards.getStandards)

    return await request
      .GetResultAsync();
  }
  async addStandards(body: StandardsDto): Promise<IGenericResponse<StandardsDto>> {
    const request = this.CreateRequestBuilder()
      .setMethod('post')
      .setBody(body)
      .setUrl(Api.Standards.addStandards)

    return await request
      .GetResultAsync()
  }
  async editStandards(body: StandardsDto): Promise<IGenericResponse<StandardsDto>> {
    const request = this.CreateRequestBuilder()
      .setMethod('put')
      .setBody(body)
      .setUrl(Api.Standards.editStandards)

    return await request
      .GetResultAsync();
  }

  async deleteStandards(standardId: number): Promise<IGenericResponse<number>> {
    const request = this.CreateRequestBuilder()
      .setMethod('delete')
      .setUrl(Api.Standards.deleteStandards, { standardId })

    return await request
      .GetResultAsync()
  }



}
